"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "startUILoading", {
  enumerable: true,
  get: function get() {
    return _startUILoading["default"];
  }
});
Object.defineProperty(exports, "stopUILoading", {
  enumerable: true,
  get: function get() {
    return _stopUILoading["default"];
  }
});
var _startUILoading = _interopRequireDefault(require("./startUILoading"));
var _stopUILoading = _interopRequireDefault(require("./stopUILoading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }